import React from "react";
import ErrorIcon from "@mui/icons-material/Error";

function ErrorMessage(props) {
  return (
    <div className="errorMessage">
    {props?.icon === false ? '' : <ErrorIcon />}
      <span>{props?.errorMessage}</span>
    </div>
  );
}

export default ErrorMessage;
